var ZigInputAmount = {
	max: "Max",
	info: {
		available: "Available:",
		min: "Min:",
		max: "Max:"
	}
};
var ZigImageInput = {
	"image-input-edit": "Edit image",
	"image-input-add": "Upload image"
};
var ZigFilters = {
	"show-results": "Show Results",
	reset: "Reset",
	min: "Min",
	to: "to",
	max: "Max",
	all: "All",
	none: "None"
};
var ZigTable = {
	"page-x": "<text>Page</text> <current>{{currentPage}}</current>",
	"page-x-of-all": "<text>Page</text> <current>{{currentPage}}</current> <text>out of</text> <total>{{totalPages}}</total>",
	"displaying-x-items_one": "<text>Displaying</text> <selector/> <text>item</text>",
	"displaying-x-items": "<text>Displaying</text> <selector/> <text>items</text>"
};
var ZigRisk = {
	"very-low-risk": "Very low risk",
	"very-low": "Very low",
	"low-risk": "Low risk",
	low: "Low",
	"average-risk": "Average risk",
	average: "Average",
	risky: "Risky",
	"very-risky": "Very risky"
};
var ZScoreRing = {
	profits: "Profits",
	risk: "Risk",
	service: "Service",
	balance: "Balance"
};
var ZigSearch = {
	search: "Search"
};
var zignalyUi = {
	ZigInputAmount: ZigInputAmount,
	ZigImageInput: ZigImageInput,
	ZigFilters: ZigFilters,
	ZigTable: ZigTable,
	ZigRisk: ZigRisk,
	ZScoreRing: ZScoreRing,
	ZigSearch: ZigSearch
};

export { ZScoreRing, ZigFilters, ZigImageInput, ZigInputAmount, ZigRisk, ZigSearch, ZigTable, zignalyUi as default };
